export const getStyles = ({ CustomerSelector = {} }, { palette = {} }) => {
  const defaultSearchBox = {
    padding: {
      top: 10,
    },
  };
  const defaultCustomerList = {
    listStyleType: 'none',
    padding: {
      left: 0,
    },
  };
  const defaultCustomerListItem = {
    padding: {
      top: 10,
    },
    '&:hover': {
      backgroundColor: palette.neutralLight,
    },
  };
  const defaultRecentCustomersHeader = {
    padding: {
      top: 10,
    },
  };
  const defaultManageCustomersHeader = {
    padding: {
      top: 10,
    },
    display: 'flex',
    justifyContent: 'space-between',
  };
  const defaultCustomerListHeaderTitle = {
    color: palette.themePrimary,
  };
  const defaultCurrentCustomerListItem = {
    fontWeight: 'bold',
  };
  const defaultCustomerTitle = {
    color: palette.neutralPrimary,
  };
  const defaultAccountCount = {
    color: palette.neutralSecondary,
  };
  const defaultAccountId = {
    color: palette.neutralSecondary,
  };
  const defaultCustomerTileFirstLine = {
    display: 'flex',
    justifyContent: 'space-between',
  };

  return {
    searchBox: { ...defaultSearchBox, ...CustomerSelector.searchBox },
    customerList: { ...defaultCustomerList, ...CustomerSelector.customerList },
    customerListItem: { ...defaultCustomerListItem, ...CustomerSelector.customerListItem },
    customerTitle: { ...defaultCustomerTitle, ...CustomerSelector.customerTitle },
    accountCount: { ...defaultAccountCount, ...CustomerSelector.accountCount },
    accountId: { ...defaultAccountId, ...CustomerSelector.accountId },
    recentCustomersHeader: {
      ...defaultRecentCustomersHeader,
      ...CustomerSelector.recentCustomersHeader,
    },
    manageCustomersHeader: {
      ...defaultManageCustomersHeader,
      ...CustomerSelector.manageCustomersHeader,
    },
    customerListHeaderTitle: {
      ...defaultCustomerListHeaderTitle,
      ...CustomerSelector.customerListHeaderTitle,
    },
    currentCustomerListItem: {
      ...defaultCurrentCustomerListItem,
      ...CustomerSelector.currentCustomerListItem,
    },
    customerTileFirstLine: {
      ...defaultCustomerTileFirstLine,
      ...CustomerSelector.customerTileFirstLine,
    },
  };
};
